export default {
  title: 'Başlık',
  notifications: 'Bildirimler',
  notification: 'Bildirim',
  announcement: 'Duyuru',
  service: 'Modül',
  displayOnRiderAppUntil: 'Yolcu uygulamasında gösterilme tarihi',
  displayUntilBeforeSendTime: 'Gösterim tarihi, bildirimin gönderim tarihinden önce olamaz.',
  noResults: 'Sonuç Yok',
  notificationDetail: 'Bildirim Detayı',
  newNotification: 'Yeni Bildirim',
  date: 'Tarih',
  sendDate: 'Gönderim Tarihi',
  type: 'Tür',
  validUntil: 'Geçerlilik Tarihi',
  message: 'Mesaj',
  route: 'Rota',
  recipients: 'Alıcılar',
  file: 'Dosya',
  users: 'kullanıcı',
  personnel: 'Personeller',
  allRoutes: 'Tüm rotalar',
  searchInResults: 'Sonuçlarda Ara',
  allCategories: 'Tüm Kategoriler',
  allStatuses: 'Tüm Statüler',
  administrative: 'İdari',
  operation: 'Operasyon',
  tickets: 'Talepler',
  ridersOnARoute: 'Bir rotadaki yolcular',
  ridersOnACampus: 'Bir kampüsteki yolcular',
  ridersRelatedToAShuttleProvider: 'Bir servis sağlayıcıyla ilişkili yolcular',
  includePassiveUsers: 'Pasif kullanıcıları dahil et',
  selectRoute: 'Rota Seç',
  campus: 'Kampüs',
  selectCampus: 'Kampüs Seç',
  shuttleProvider: 'Servis Şirketleri',
  selectShuttleProvider: 'Servis Şirketi Seçin',
  typeMessageTitle: 'Mesaj başlığı yazın',
  typeMessage: 'Mesaj Yazın',
  attachments: 'Ekler (İsteğe Bağlı)',
  send: 'Gönder',
  cancel: 'İptal',
  notificationSent: 'Bildirim gönderildi ✓',
  notificationDeleted: 'Bildirim silindi',
  notificationUpdated: 'Bildirim güncellendi',
  confirmDelete: 'Bu bildirimi silmek istediğinizden emin misiniz?',
  confirmDeleteNotification: 'Bu bildirimi silmek istediğinizden emin misiniz?',
  confirmDeleteAnnouncement: 'Bu duyuruyu silmek istediğinizden emin misiniz?',
  editNotification: 'Bildirimi Düzenle',
  editAnnouncement: 'Duyuruyu Düzenle',
  files: 'Dosyalar',
  none: 'Hiçbiri',
  recipient: 'Alıcı',
  searchRecipientName: 'Alıcı ismini ara',
  filterByCampus: 'Kampüse göre filtrele',
  filterByServiceUsers: 'Hizmete göre filtrele',
  allServices: 'Tüm hizmetler',
  specificProviders: 'Belirli Servis Şirketleri',
  specificRoutes: 'Belirli Rotalar',
  areYouSure: 'Emin misiniz?',
  content: 'İçerik',
  'SSE-NEW-FLEXIRIDE-REQUEST': 'Yeni Rezervasyon Talebi',
  'SSE-NEW-FLEXIRIDE-CHANGE-REQUEST': 'Yeni Değişiklik Talebi',
  'SSE-NEW-FLEXIRIDE-DRAFT-REQUEST': 'Yeni Taslak',
  'SSE-UPDATED-FLEXIRIDE-REQUEST': 'Flexiride İsteği Güncellendi',
  'SSE-CANCELED-FLEXIRIDE-REQUEST-BY-EA': 'Flexiride isteği EA tarafından iptal edildi',
  'SSE-CANCELED-FLEXIRIDE-REQUEST-BY-RIDER': 'Flexiride isteği kullanıcı tarafından iptal edildi',
  'SSE-SKIPPED-FLEXIRIDE-REQUEST-BY-DRIVER': 'Flexiride isteği sürücü tarafından atlandı',
  'SSE-DRIVER-LOCATION-ALERT':
    'Sürücü {driverName}, {assignmentStartTime} saatinde başlayan {routeName} rotasına atanmış ve {controlTime} itibariyle depodan {driverDistanceToDepot} metre uzaklıkta',
  'SSE-DRIVER-ONLINE-ALERT':
    'Sürücü {driverName}, {assignmentStartTime} saatinde başlayan {routeName} rotasına atanmış ancak {controlTime} itibariyle çevrimiçi değil',
  'SSE-DELAYED_TRIP_ALERT':
    '{departureHour} {routeName}, {vehicleName} ve {driverName} atanmış olup henüz ilk durağı terk etmedi.',
  sendTheNotification: 'Bildirim gönder',
  onScheduledTime: 'Planlanan zamanda',
  scheduledNotificationMessage: 'Bildirim, {0} yolcuya, {1} tarihinde, {2} saatinde gönderilecek',
  confirmScheduledNotificationMessage:
    'Lütfen bildirimin {0} yolcuya, {1} tarihinde, {2} saatinde gönderilmesini onaylayın',
  notificationSentMessage: 'Bildirim {0} yolcuya gönderildi',
  confirmSendNotificationMessage: 'Lütfen bildirimi seçili yolculara göndermek isteyip istemediğinizi onaylayın',
  confirmScheduledSendNotificationMessage:
    'Lütfen bildirimin seçili yolculara, {0} tarihinde {1} saatinde gönderilmesini onaylayın.',
  confirmScheduledSendAnnouncementMessage:
    'Lütfen duyurunun seçili yolculara, {0} tarihinde {1} saatinde gönderilmesini onaylayın.',
  sendTheNotificationToAllRidersOn: 'Seçilen kullanıcılara bildirim göndermek istiyor musunuz?',
  sendTheAnnouncementToAllRidersOn: 'Seçilen kullanıcılara duyuru göndermek istiyor musunuz?',
  ridersLastTwoMonths: 'Hizmeti son 2 ayda kullanmış olan kullanıcılara bildirim gönderilecektir.',
  rider: {
    noNotifications: 'Bildirim yok',
    noNotificationsAltText: 'Bildirimleriniz bu alanda görünecektir.',
    wantToDelete: 'Seçili bildirimleri silmek istiyor musunuz?',
  },
};
